import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { InfoAlertComponent } from './component/info-alert/info-alert.component';
import { InfoConfirmComponent } from './component/info-confirm/info-confirm.component';
import { ErrorAlertComponent } from './component/error-alert/error-alert.component';
import { IndeterminateProgressBarComponent } from './component/indeterminate-progress-bar/indeterminate-progress-bar.component';
import { GlobalComponentService } from './global-component.service';
import { TmModalComponent } from './component/tm-modal/tm-modal.component';
import { TmModalHeaderComponent } from './component/tm-modal-header/tm-modal-header.component';
import { TmModalBodyComponent } from './component/tm-modal-body/tm-modal-body.component';
import { TmModalFooterComponent } from './component/tm-modal-footer/tm-modal-footer.component';
import { ReusableInfoConfirmComponent } from './component/reusable-info-confirm/reusable-info-confirm.component';
import { ReusableInfoAlertComponent } from './component/reusable-info-alert/reusable-info-alert.component';
import { ReusableErrorAlertComponent } from './component/reusable-error-alert/reusable-error-alert.component';


@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    MatSnackBarModule,
    MatProgressBarModule,
    MatButtonModule,
  ],
  declarations: [
    TmModalComponent,
    TmModalHeaderComponent,
    TmModalBodyComponent,
    TmModalFooterComponent,
    InfoAlertComponent,
    InfoConfirmComponent,
    ErrorAlertComponent,
    IndeterminateProgressBarComponent,
    ReusableInfoConfirmComponent,
    ReusableInfoAlertComponent,
    ReusableErrorAlertComponent,
  ],
  exports: [
    TmModalComponent,
    TmModalHeaderComponent,
    TmModalBodyComponent,
    TmModalFooterComponent,
    InfoAlertComponent,
    InfoConfirmComponent,
    ErrorAlertComponent,
    IndeterminateProgressBarComponent,
    ReusableInfoConfirmComponent,
    ReusableInfoAlertComponent,
    ReusableErrorAlertComponent,
  ]
})
export class GlobalModule {
  static forRoot(): ModuleWithProviders<GlobalModule> {
    return { ngModule: GlobalModule, providers: [GlobalComponentService] };
  }
}
